import React from "react";
import Loader from "../../components/Loader/Loader";
import { getLoggedUser } from "../../utils/helpers/tokenStorage";
import CampaignList from "./CampaignList";

const index = () => {
  const user = getLoggedUser()?.user?.user;
  /*@ts-ignore*/
  return !user ? <Loader /> : <CampaignList />;
};

export default index;
